export const codeLanguageMap = {
  en: "English",
  es: "Español", // Spanish
}

export const codeLanguageAbbreviationMap = {
  en: "Eng",
  es: "Esp", // Spanish
}
